import { render, staticRenderFns } from "./GeneralInformationPage.vue?vue&type=template&id=46410258&scoped=true&"
import script from "./GeneralInformationPage.vue?vue&type=script&lang=js&"
export * from "./GeneralInformationPage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInformationPage.vue?vue&type=style&index=0&id=46410258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46410258",
  null
  
)

export default component.exports